import { StandardRatePayload } from "us.collection.admin/interfaces"
import { DateFormats  } from "us.common/constants"
import _ from "lodash";
import dayjs from "dayjs";

export function SaveStandardRate(this: any): StandardRatePayload {
  return {
    rateId: this.rateId,
    rate: Number(this.rate.toFixed(2)),
    effectiveDate: dayjs(this.effectiveDate).format(DateFormats.FORMAT_1),
    comment: this.comment
  };
}
